import React from 'react';
import styled from 'styled-components';
import qs from 'query-string';
import {useOutlet} from 'reconnect.js';
import * as Ant from 'antd';
import * as JStorage from 'rev.sdk.js/Actions/JStorage';
import * as AppActionsEx from '../../AppActions/custom';
import TeamIntroduction from '../TeamIntroduction';
import TeamPersonnel from '../TeamPersonnel';
import TeamOfficierList from '../TeamOfficerList';
import TeamSpecialCommitteeList from '../TeamSpecialCommitteeList';
import TeamDomainCommitteeList from '../TeamDomainCommitteeList';
import TeamStaffList from '../TeamStaffList';

export default function TeamContent(props) {
  const params = qs.parse(props.location.search);
  const isPreview = params && params.preview && Boolean(params.preview);

  const [locale, setLocale] = useOutlet('locale');
  const lang = locale.lang;
  const [introduction, setIntroduction] = React.useState(null);
  const [personnel, setPersonnel] = React.useState(null);
  const [officerList, setOfficerList] = React.useState(null);
  const [specialCommitteeList, setSpecialCommitteeList] = React.useState(null);
  const [domainCommitteeList, setDomainCommitteeList] = React.useState(null);
  const [staffList, setStaffList] = React.useState(null);

  const fetchData = React.useCallback(async () => {
    let results = [];

    try {
      if (isPreview) {
        results = await JStorage.fetchAllDocuments('site', {
          name: {$regex: 'team'},
        });
      } else {
        results = await AppActionsEx.getTeamJsonFromS3Bucket();
      }

      for (let i = 0; i < results.length; i++) {
        let record = results[i];
        if (record.name === 'team_introduction') {
          setIntroduction(record);
        } else if (record.name === 'team_personnel') {
          setPersonnel(record);
        } else if (record.name === 'team_officer_list') {
          setOfficerList(record);
        } else if (record.name === 'team_special_committee_list') {
          setSpecialCommitteeList(record);
        } else if (record.name === 'team_domain_committee_list') {
          setDomainCommitteeList(record);
        } else if (record.name === 'team_staff_list') {
          setStaffList(record);
        }
      }
    } catch (err) {
      console.warn(err);
      Ant.message.error('發生錯誤');
    }
  }, [isPreview]);

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <Wrapper lang={lang}>
      <TeamIntroduction data={introduction} />
      <TeamPersonnel data={personnel} />
      <TeamOfficierList data={officerList} />
      <TeamSpecialCommitteeList data={specialCommitteeList} />
      <TeamDomainCommitteeList data={domainCommitteeList} />
      <TeamStaffList data={staffList} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin: 0 auto;
  max-width: ${(props) => (props.lang === 'tw' ? '850px' : '1200px')};
  width: 100%;

  .ant-descriptions-item-label,
  .ant-descriptions-item-content {
    padding: 10px 20px !important;
  }
`;
